"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("react");

var _react2 = require("@emotion/react");

var _Card = _interopRequireDefault(require("../svg/Card"));

var _Card2 = _interopRequireDefault(require("../svg/legacy/Card"));

var css = _interopRequireWildcard(require("./VGSIframe.styles"));

var _loadShowJS = _interopRequireDefault(require("./loadShowJS"));

var _svg = require("../../../components/icon/svg");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var BULLETS = '&#8226;&#8226;&#8226;&#8226;';

var VGSIframe = function VGSIframe(_ref) {
  var scriptSrc = _ref.scriptSrc,
      vaultId = _ref.vaultId,
      cardNumberReq = _ref.cardNumberReq,
      cvvReq = _ref.cvvReq,
      expiryDate = _ref.expiryDate,
      name = _ref.name,
      onCopyHandler = _ref.onCopyHandler,
      onUpdateHandler = _ref.onUpdateHandler,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? false : _ref$enabled,
      _ref$isMasked = _ref.isMasked,
      isMasked = _ref$isMasked === void 0 ? false : _ref$isMasked;
  var cardNumberRef = (0, _react.useRef)(null);
  var cvvRef = (0, _react.useRef)(null);
  var copyRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      ready = _useState2[0],
      setReady = _useState2[1];

  var theme = (0, _react2.useTheme)();
  (0, _react.useEffect)(function () {
    if (!enabled) {
      setReady(false);
    }
  }, [enabled]);
  var callback = (0, _react.useCallback)(function (states) {
    var statesArray = Object.values(states);
    var isReady = statesArray.every(function (state) {
      return state.revealed;
    });

    if (isReady) {
      setReady(isReady);
    }

    onUpdateHandler(isReady, states);
  }, [onUpdateHandler]);
  (0, _react.useEffect)(function () {
    (0, _loadShowJS["default"])(scriptSrc, function () {
      if (enabled && window.VGSShow && !ready) {
        cardNumberRef.current.innerHTML = '';
        cvvRef.current.innerHTML = '';
        copyRef.current.innerHTML = '';
        var showJs = window.VGSShow.create(vaultId, callback);

        var cardNumberRequest = _objectSpread(_objectSpread({}, cardNumberReq), {}, {
          name: 'get-card-number',
          serializers: [showJs.SERIALIZERS.replace('(\\S{4})(\\S{4})(\\S{4})(\\S{4})', "$1 $2 $3 $4")]
        });

        if (isMasked) {
          cardNumberRequest.serializers = [showJs.SERIALIZERS.replace('(\\S{4})(\\S{4})(\\S{4})(\\S{4})', "".concat(BULLETS, " ").concat(BULLETS, " ").concat(BULLETS, " $4"))];
          cvvRef.current.innerHTML = '•••';
        } else {
          var cvvRequest = _objectSpread(_objectSpread({}, cvvReq), {}, {
            name: 'get-cvv'
          });

          var cvv = showJs.request(cvvRequest);
          cvv.render(cvvRef.current, css.iframeCvv);
        }

        var cardNumber = showJs.request(cardNumberRequest);
        cardNumber.render(cardNumberRef.current, css.iframeCardNumber);

        if (onCopyHandler && !isMasked) {
          var copyButton = showJs.copyFrom(cardNumber, {
            text: '',
            serializers: [showJs.SERIALIZERS.replace(' ', '')]
          }, onCopyHandler);
          copyButton.render(copyRef.current, css.iframeCopy);
        }
      }
    });
  }, [cardNumberReq, cvvReq, isMasked, scriptSrc, vaultId, enabled, callback, onCopyHandler, ready, theme.name]);
  return (0, _jsxRuntime.jsxs)("div", {
    css: css.vgsIframe,
    children: [theme.name === 'legacy' ? (0, _jsxRuntime.jsx)(_Card2["default"], {
      css: css.card
    }) : (0, _jsxRuntime.jsx)(_Card["default"], {
      css: css.card
    }), enabled && (0, _jsxRuntime.jsx)("div", {
      className: "fs-exclude",
      css: [css.cardNumber(theme), ready ? '' : css.hide],
      ref: cardNumberRef
    }), !ready && (0, _jsxRuntime.jsx)("div", {
      css: css.cardNumber,
      children: "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022"
    }), (0, _jsxRuntime.jsxs)("div", {
      css: css.expiryCvv,
      children: [(0, _jsxRuntime.jsx)("div", {
        className: "fs-mask",
        css: css.expiry,
        children: isMasked || !ready ? '••/••' : expiryDate
      }), enabled && (0, _jsxRuntime.jsx)("div", {
        className: "fs-exclude",
        css: [css.cvv, ready ? '' : css.hide],
        ref: cvvRef
      }), !ready && (0, _jsxRuntime.jsx)("div", {
        css: css.cvv,
        children: "\u2022\u2022\u2022"
      })]
    }), (0, _jsxRuntime.jsx)("span", {
      className: "fs-mask",
      css: css.fullName,
      children: name
    }), onCopyHandler && enabled && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [(0, _jsxRuntime.jsx)("div", {
        className: "fs-exclude ".concat(css.copyButton),
        css: [css.copyButton(theme), !ready || isMasked ? css.greyedOutcopyButton(theme) : ''],
        ref: copyRef
      }), (0, _jsxRuntime.jsx)("div", {
        css: [css.copyIcon, !ready || isMasked ? css.greyedOutcopyIcon : ''],
        children: (0, _jsxRuntime.jsx)(_svg.Copy, {
          fill: theme.name === 'legacy' ? theme.colors.white : theme.colors.muted
        })
      })]
    })]
  });
};

var _default = VGSIframe;
exports["default"] = _default;